"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleCurrentItems = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries


var handleCurrentItems = function handleCurrentItems(currentIndex, totalItems, itemsPerPage) {
  var endNumbers = currentIndex > totalItems ? totalItems : currentIndex; // make sure we dont display higher number than the total amount of items

  return "".concat(currentIndex + 1 - itemsPerPage, "-").concat(endNumbers);
};

exports.handleCurrentItems = handleCurrentItems;